import { useEffect } from "react";
import { useAuth } from "./identity-auth0-context";

export const LogoutCallback: React.FC = () => {
  const { signoutRedirectCallback } = useAuth();

  useEffect(() => {
    const signout = async () => {
      if (signoutRedirectCallback) {
        await signoutRedirectCallback();
      }
    };

    signout();
  }, [signoutRedirectCallback]);

  return null; // or a loading indicator if needed
};

export default LogoutCallback;
